import './App.css';
import { BrowserRouter as Router } from "react-router-dom"
import Routing from './routes';
import './assets/vendors/animate/animate.min.css'
import './assets/vendors/fontawesome/css/all.min.css'
import './assets/vendors/insuco-icons/flaticon_insuco.css'
import './assets/vendors/jquery-nice-select/css/nice-select.css'
import './assets/vendors/owl-carousel/dist/assets/owl.carousel.min.css'
import './assets/vendors/owl-carousel/dist/assets/owl.theme.default.min.css'
import './assets/vendors/jquery-magnific-popup/jquery.magnific-popup.css'
import './assets/vendors/youtube-popup/youtube-popup.css'
import './assets/vendors/bootstrap-datepicker/css/bootstrap-datepicker.min.css'
import './assets/vendors/ion.rangeSlider/css/ion.rangeSlider.min.css'
import './assets/vendors/bootstrap/css/bootstrap.min.css'
import './assets/css/insuco.css'

function App() {
  return (
    <>
      <Router basename='/'>
          <Routing />
      </Router>
    </>
  );
}

export default App;
